import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-more-ver",
  templateUrl: "./med-icon-more-ver.component.html",
})
export class MedIconMoreVerComponent extends SvgMixinComponent {}
